export const defaultState = {
  loginNumber: null,
  loginCountryCode: null,
  otpError: null,
  appError: {
    hasError: false,
    errorTitle: 'Something went wrong',
    errorDesc: 'Check your internet connection and try again'
  }
};

export default function app(state = defaultState, action) {
  switch (action.type) {
    case 'OTP_SENT':
      return Object.assign({}, state, {
        loginNumber: action.payload.phoneNumber,
        loginCountryCode: action.payload.countryCode
      });
    case 'OTP_FAILURE': {
      return Object.assign({}, state, {
        otpError: action.payload
      });
    }
    case 'SHOW_ERROR': {
      return Object.assign({}, state, {
        appError: {
          hasError: true,
          errorTitle: action.payload.errorTitle,
          errorDesc: action.payload.errorDesc
        }
      });
    }
    case 'HIDE_ERROR': {
      return Object.assign({}, state, {
        appError: {
          hasError: false,
          errorTitle: 'Something went wrong',
          errorDesc: 'Check your internet connection and try again'
        }
      });
    }
    default:
      return state;
  }
}
